export const CATEGORIES = [
  {
    id: 'forum',
    name: '早期论坛',
    en: 'EARLY FORUMS',
    desc: '中文互联网最初的聊天室与BBS往事，从拨号时代一路翻到门户论坛的黄金期。',
    count: 128,
    icon: 'ri-chat-history-line',
    cover:
      'https://readdy.ai/api/search-image?query=nostalgic%20early%20internet%20forum%20screens%20glowing%20on%20a%20retro%20crt%20monitor%20in%20a%20dark%20room%2C%20amber%20phosphor%20glow%2C%20dusty%20keyboard%2C%20moody%20archival%20atmosphere%2C%20warm%20brown%20tones%2C%20cinematic%20still%20life&width=800&height=560&seq=hlkb-cat-forum-01&orientation=landscape',
  },
  {
    id: 'deleted',
    name: '被删档案',
    en: 'DELETED FILES',
    desc: '消失的帖子、下架的节目、返回404的页面，靠备份与截图重新拼回来的内容。',
    count: 214,
    icon: 'ri-delete-bin-6-line',
    cover:
      'https://readdy.ai/api/search-image?query=torn%20printed%20screenshots%20and%20redacted%20documents%20scattered%20on%20a%20dark%20wooden%20desk%2C%20a%20404%20error%20page%20on%20an%20old%20laptop%2C%20warm%20amber%20desk%20lamp%2C%20moody%20archival%20mood%2C%20brown%20and%20gold%20palette&width=800&height=560&seq=hlkb-cat-deleted-01&orientation=landscape',
  },
  {
    id: 'subculture',
    name: '小众亚文化',
    en: 'SUBCULTURES',
    desc: '圈层黑话、同好聚集地与早已解散的冷门社团，记录它们曾经怎样自成一国。',
    count: 96,
    icon: 'ri-shapes-line',
    cover:
      'https://readdy.ai/api/search-image?query=shadowy%20underground%20room%20filled%20with%20handmade%20zines%20and%20stickers%2C%20strings%20of%20small%20photographs%20hung%20on%20a%20dark%20wall%2C%20single%20warm%20bulb%2C%20gritty%20texture%2C%20warm%20amber%20and%20deep%20brown%20tones&width=800&height=560&seq=hlkb-cat-subculture-01&orientation=landscape',
  },
  {
    id: 'retro',
    name: '尘封老游戏',
    en: 'FADED GAMES',
    desc: '停运的网游、被遗忘的页游与单机，玩家们用私服和模拟器把它们留了下来。',
    count: 74,
    icon: 'ri-gamepad-line',
    cover:
      'https://readdy.ai/api/search-image?query=pixel%20art%20retro%20video%20game%20scene%20on%20an%20old%20monitor%2C%20dusty%20game%20console%20and%20cartridges%20on%20a%20dark%20shelf%2C%20warm%20amber%20glow%2C%20nostalgic%20archival%20atmosphere%2C%20brown%20gold%20tones&width=800&height=560&seq=hlkb-cat-retro-01&orientation=landscape',
  },
  {
    id: 'vanished',
    name: '消失的网站',
    en: 'VANISHED SITES',
    desc: '曾经首页流量百万、如今打不开的老站，把它们的结构与栏目重新画出来。',
    count: 88,
    icon: 'ri-global-line',
    cover:
      'https://readdy.ai/api/search-image?query=abandoned%20website%20layout%20screenshot%20pinned%20to%20a%20dark%20corkboard%2C%20old%20browser%20window%20frames%2C%20connected%20by%20red%20string%2C%20warm%20directional%20light%2C%20detective%20archival%20mood%2C%20amber%20and%20rust%20tones&width=800&height=560&seq=hlkb-cat-vanish-01&orientation=landscape',
  },
  {
    id: 'meme',
    name: '迷因考古',
    en: 'MEME ORIGINS',
    desc: '那句被用烂的梗最早从哪里冒出来？沿着弹幕、回帖和时间戳往回追。',
    count: 102,
    icon: 'ri-emotion-laugh-line',
    cover:
      'https://readdy.ai/api/search-image?query=layered%20meme%20images%20and%20timestamped%20screenshots%20overlapping%20on%20a%20dark%20surface%2C%20glowing%20screen%20reflections%2C%20warm%20amber%20accent%20light%2C%20gritty%20texture%2C%20earthy%20brown%20palette%2C%20editorial%20collage&width=800&height=560&seq=hlkb-cat-meme-01&orientation=landscape',
  },
];